import { render, staticRenderFns } from "./ParentCarersEOIDetails.vue?vue&type=template&id=57f39b78&scoped=true&"
import script from "./ParentCarersEOIDetails.vue?vue&type=script&lang=js&"
export * from "./ParentCarersEOIDetails.vue?vue&type=script&lang=js&"
import style0 from "./ParentCarersEOIDetails.vue?vue&type=style&index=0&id=57f39b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f39b78",
  null
  
)

export default component.exports